import LineText from "../LineText";
import React from "react";
import "./styles.css";

const UBChip = ({ title, onSelect = undefined, className = "", ...props }) => {
  return (
    <div
      {...props}
      className={`chip-component ${className}`}
      onClick={onSelect}
    >
      <LineText className="fontSize12">{title}</LineText>
    </div>
  );
};

export default UBChip;
